
<!--
  ~ VNCmail : A whole new experience in enterprise email communication.
  ~ Copyright (C) 2015-2020 VNC – Virtual Network Consult AG (info@vnc.biz)
  ~
  ~ This program is free software: you can redistribute it and/or modify
  ~ it under the terms of the GNU Affero General Public License as published by
  ~ the Free Software Foundation, version 3 of the License.
  ~
  ~ This program is distributed in the hope that it will be useful,
  ~ but WITHOUT ANY WARRANTY; without even the implied warranty of
  ~ MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
  ~ GNU Affero General Public License for more details.
  ~
  ~ You should have received a copy of the GNU Affero General Public License
  ~ along with this program. Look for COPYING file in the top folder.
  ~ If not, see http://www.gnu.org/licenses/.
  -->

<div class="header mobile-appearance-header" *ngIf="isMobileScreen" [ngClass]="{ 'carbon-theme-header': currentTheme === 'carbon' }">
    <div class="mobile-back" (click)="close()">
        <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <g id="Icon/product/arrow-back" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <g id="Icon-24px" transform="translate(4.000000, 4.000000)" fill="#000">
                    <polygon id="Shape" points="16 7 3.83 7 9.42 1.41 8 0 0 8 8 16 9.41 14.59 3.83 9 16 9"></polygon>
                </g>
            </g>
        </svg>
    </div>
    <div class="text">{{ 'APPEARANCE' | translate }}</div>
    <button class="check-icon" mat-button (click)="updateTheme()" *ngIf="isThemeChange && isMobileScreen">
        <mat-icon>check</mat-icon>
    </button>
</div>
    <vnc-header *ngIf="!isMobileScreen"
    class="message"
    title="{{ 'APPEARANCE' | translate }}"
    type="title-close"
    size="l"
    (onCloseClick)="close()"
    [showCloseIcon]="true"
    closeIconToolTip="{{ 'CLOSE' | translate }}">
    </vnc-header>
<div class="content" [ngClass]="{ 'desktop-content': !isMobileScreen }" [ngClass]="{ 'carbon-theme': (currentTheme == 'carbon' && !isFluid) }">
    <div class="theme-lbl">{{ 'THEME_LBL' | translate | uppercase}}</div>
    <div class="themes">
        <mat-radio-group class="swipe-radio-group" (change)="themeChange($event)" [(ngModel)]="selectedAction">
            <div>
                <div [ngClass]="{ 'selected-border': selectedAction === 'default' }">
                    <svg width="336" height="128" viewBox="0 0 336 128" xmlns="http://www.w3.org/2000/svg">
                        <g fill="none" fill-rule="evenodd">
                            <rect stroke="#DADEE2" fill="#FFF" x=".5" y=".5" width="335" height="127" rx="6"/>
                            <path d="M6 0h324a6 6 0 0 1 6 6v26H0V6a6 6 0 0 1 6-6z" fill="#337CBD"/>
                            <rect stroke="#DADEE2" fill="#F5F8FA" x="8.5" y="44.5" width="202.268" height="31" rx="4"/>
                            <rect stroke="#DADEE2" fill="#FFF" x="125.232" y="84.5" width="202.268" height="31" rx="4"/>
                        </g>
                    </svg>
                </div>
                <mat-radio-button value="default">
                    {{'Blue Ocean' | translate }}
                </mat-radio-button>
            </div>
            <div>
                <div [ngClass]="{ 'selected-border': selectedAction === 'dfb' }">
                    <svg width="336" height="128" viewBox="0 0 336 128" xmlns="http://www.w3.org/2000/svg">
                        <g fill="none" fill-rule="evenodd">
                            <rect stroke="#DADEE2" fill="#FFF" x=".5" y=".5" width="335" height="127" rx="6"/>
                            <path d="M6 0h324a6 6 0 0 1 6 6v26H0V6a6 6 0 0 1 6-6z" fill="#20AE80"/>
                            <rect fill="#93DB4B" opacity=".32" x="8" y="44" width="203.268" height="32" rx="4"/>
                            <rect fill="#93DB4B" x="124.732" y="84" width="203.268" height="32" rx="4"/>
                        </g>
                    </svg>
                </div>
                <mat-radio-button value="dfb">
                    {{'Nature Green' | translate }}
                </mat-radio-button>
            </div>
            <div>
                <div [ngClass]="{ 'selected-border': selectedAction === 'carbon' }">
                    <svg width="336" height="128" viewBox="0 0 336 128" xmlns="http://www.w3.org/2000/svg">
                        <g fill="none" fill-rule="evenodd">
                            <rect stroke="#373e45" fill="#191a1c" x=".5" y=".5" width="335" height="127" rx="6"/>
                            <path d="M6 0h324a6 6 0 0 1 6 6v26H0V6a6 6 0 0 1 6-6z" fill="#000"/>
                            <rect fill="#282f35" opacity=".32" x="8" y="44" width="203.268" height="32" rx="4"/>
                            <rect fill="#282f35" x="124.732" y="84" width="203.268" height="32" rx="4"/>
                        </g>
                    </svg>
                </div>
                <mat-radio-button value="carbon">
                    {{'Carbon' | translate }}
                </mat-radio-button>
            </div>
        </mat-radio-group>
    </div>
</div>

<div class="restore-default" *ngIf="isMobileScreen" [ngClass]="{ 'carbon-restore-default': currentTheme === 'carbon' }">
    <div (click)="restoreDefaultTheme()" style="display: flex;">
        <svg width="18px" height="18px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <g id="Icon/product/sync" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <g id="Icon-24px" transform="translate(4.000000, 1.000000)" fill="#8B96A0">
                    <path d="M8,3 L8,0 L4,4 L8,8 L8,5 C11.31,5 14,7.69 14,11 C14,12.01 13.75,12.97 13.3,13.8 L14.76,15.26 C15.54,14.03 16,12.57 16,11 C16,6.58 12.42,3 8,3 L8,3 Z M8,17 C4.69,17 2,14.31 2,11 C2,9.99 2.25,9.03 2.7,8.2 L1.24,6.74 C0.46,7.97 0,9.43 0,11 C0,15.42 3.58,19 8,19 L8,22 L12,18 L8,14 L8,17 L8,17 Z" id="Shape"></path>
                </g>
            </g>
        </svg>
        <span>{{ 'RESTORE_DEFAULTS' | translate }}</span>
    </div>
</div>
<vnc-footer class="calendar-menu-action" [secondaryLabel]="'CANCEL_MAIL_LABEL' | translate | uppercase"
    *ngIf="!isMobileScreen"
    [primaryLabel]="'SAVE' | translate | uppercase"
    [ngClass]="{ 'dfb-theme': (currentTheme === 'dfb' && !isFluid) }"
    [type]="'secondary-primary'"
    [color]="'white'"
    (onSecondaryClick)="close()"
    [isPrimaryDisabled]="!isThemeChange"
    (onPrimaryClick)="updateTheme()">
</vnc-footer>